import {
  getPricePlanDescription,
  isHighDenominationLocale,
} from 'common/components/entities/price-element/utils'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React from 'react'
import {
  PriceElementPeriodInterface,
  PricePlanPeriodType,
} from '../price-element-interface'
import { CommonPriceElementUnknownUi } from '../ui'
import {
  PriceElementBottomSectionUi,
  PriceElementPlanButtonUi,
  PriceElementPlanDescriptionUi,
  PriceElementPlanPriceUi,
  PriceElementPlanSubtitleUi,
  PriceElementPlansUi,
  PriceElementPlanTitleUi,
  PriceElementPlanUi,
} from './ui'

interface CommonPriceElementPlansProps {
  plans: PriceElementPeriodInterface[]
  locale: PageLocaleEnum
  t: TFunction
  isLoading: boolean
  onClick: (id: number, activeBtn: PricePlanPeriodType) => void
  activeBtn: PricePlanPeriodType
}

export const CommonPriceElementPlans = ({
  plans,
  onClick,
  locale,
  t,
  isLoading,
  activeBtn,
}: CommonPriceElementPlansProps) => {
  const handlePopupBtn = (idx: number) => {
    if (isLoading) {
      return false
    }
    onClick(idx, activeBtn)
  }

  return (
    <PriceElementPlansUi
      isDisabled={isLoading}
      locale={locale}
      planCount={plans.length}
    >
      {plans.map((plan, idx) => {
        const description = getPricePlanDescription(plan.id)

        return (
          <PriceElementPlanUi
            data-test-plan={plan.title}
            data-test-price={plan.cost}
            key={plan.title ?? `${idx}`}
          >
            <div>
              <PriceElementPlanTitleUi locale={locale}>
                {plan.title ?? <CommonPriceElementUnknownUi />}
              </PriceElementPlanTitleUi>
              {description && (
                <PriceElementPlanDescriptionUi className="price-plan-description">
                  {t(description)}
                </PriceElementPlanDescriptionUi>
              )}
            </div>

            <PriceElementBottomSectionUi>
              <PriceElementPlanPriceUi
                locale={locale}
                isSmall={isHighDenominationLocale(locale)}
                className="price-plan-value"
              >
                {plan.cost ?? <CommonPriceElementUnknownUi width="30px" />}
              </PriceElementPlanPriceUi>
              <PriceElementPlanSubtitleUi
                isVisible={plan.isFree}
                className="price-plan-subtitle"
              >
                {t('components.price_element.plan_price_subtitle')}
              </PriceElementPlanSubtitleUi>
              <PriceElementPlanButtonUi
                type="button"
                locale={locale}
                onClick={() => handlePopupBtn(idx)}
                isDisabled={isLoading}
              >
                {t('components.price_element.popup_button')}
              </PriceElementPlanButtonUi>
            </PriceElementBottomSectionUi>
          </PriceElementPlanUi>
        )
      })}
    </PriceElementPlansUi>
  )
}
